/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var BroadcastArrowDownIcon = createIcon("BroadcastArrowDownIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#000';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M35 13.748 20.707 28.04a.999.999 0 01-1.414 0L5 13.748",
    stroke: _color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});